import {
  Table,
  TableRowAllowSettings,
} from "../../../../../requests/table/types";

// eslint-disable-next-line
export const DEFAULT_TABLE_DATA: Table = {
  name: "",
  type: "",
  columns: {},
  schema: "",
  rows: [],
  count: 0,
  allowSettings: {} as TableRowAllowSettings,
  currentPage: null,
};
